import { Component } from '@angular/core';
import { MAPSSearchLogEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Search Logs') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapssearchlog-form',
    templateUrl: './mapssearchlog.form.component.html'
})
export class MAPSSearchLogFormComponent extends BaseFormComponent {
    public record!: MAPSSearchLogEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'exportLogs', sectionName: 'Export Logs', isExpanded: false },
            { sectionKey: 'uploadedDocuments', sectionName: 'Uploaded Documents', isExpanded: false },
            { sectionKey: 'contactMessages', sectionName: 'Contact Messages', isExpanded: false }
        ]);
    }
}

